import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledCardContainer = styled.div`
  display: grid;
  grid-row-gap: 3rem;
  margin-top: 4rem;
  ${(props) =>
    props.align === "start" || props.align === "end"
      ? `justify-content: flex-${props.align}`
      : `justify-content: center`};
  ${(props) =>
    props.equalize ? `align-items: flex-start` : `align-items: center`};
  padding-bottom: 4rem;

  ${(props) => props.theme.media.tablet_landscape_up`
    display: grid;
    grid-template-columns: ${props.columns};
    grid-column-gap: 1.5%;
    grid-auto-flow: both;
    margin-top: 4rem;
  `}
`

function CardContainer({ children, ...props }) {
  return <StyledCardContainer {...props}>{children}</StyledCardContainer>
}

export default CardContainer

CardContainer.defaultProps = {
  align: "center",
  columns: "1fr 1fr 1fr",
}

CardContainer.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(["start", "center", "end"]),
  columns: PropTypes.string,
}
